// src/utils/auth.js
import jwtDecode from "jwt-decode";

const AUTH_TOKEN = "auth-token";
const AUTH_EXPIRY = "authExp";

export function saveAuthToken(token) {
  try {
    const decoded = jwtDecode(token);
    const exp = decoded.exp; // exp in seconds (UNIX timestamp)

    const now = Math.floor(Date.now() / 1000);
    // Custom expiry: 2 minutes (120 seconds) from now
    const manualExp = now + 120;

    // console.log("token exp time", manualExp);
    // console.log("token exp time jwt", exp);
    // debugger;
    localStorage.setItem(AUTH_TOKEN, token);
    localStorage.setItem(AUTH_EXPIRY, exp.toString());
  } catch (error) {
    console.error("Invalid token", error);
  }
}

export function getAuthToken() {
  return localStorage.getItem(AUTH_TOKEN);
}

export function isTokenExpired() {
  const expiry = localStorage.getItem(AUTH_EXPIRY);
  if (!expiry) return true;

  const now = Math.floor(Date.now() / 1000);
  return now > parseInt(expiry, 10);
}

export function clearAuthToken() {
  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem(AUTH_EXPIRY);
}
